<p-dialog [(visible)]="visibleIngreso" [closable]="false" [modal]="true" [header]="'Ingresar Número de Documento'">
  <div class="p-fluid" style="display: flex; flex-direction: column; align-items: center;">

    <!-- Campo de entrada del número de documento -->
    <div class="p-field" style="width: 100%; text-align: center;">
      <input id="numeroDocumento" type="text" pInputText [(ngModel)]="numeroDocumento"
        style="max-width: 80vw;width: 400px">
    </div>

    <div style="text-align: center; margin-top: 16px; width: 100%;">
      <button pButton type="button" class="btn btn-primary" style="max-width: 200px; width: 100%"
        (click)="submitNumeroDocumento()">Enviar</button>
    </div>

  </div>
</p-dialog>
<ng-container *ngIf="puedeIngresar">
  <div class="top-bar custom-center p-1">
    <p>Tiempo restante: {{ remTimeFormat }}</p>
  </div>

  <div style="width: 100%; position: absolute; top: 0" *ngIf="form">|

    <div class="pl-4 pr-4 pt-4">
      <div class="card p-3">
        <div class="card-body justify-content-center d-flex">
          <div class="row p-2" #el [style]="{ width: '100%' }">
            <div class="custom-center justify-content-start">
              <img class="mr-4" src="assets/img/logo/logo-bg-none.png" width="50" alt="Evaluaciones Online Shell">
              <h4>Shell: Evaluaciones online</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pl-4 pr-4 pt-4">
      <div class="card p-3 card-complete" [ngClass]="{'hide': !visibility}">
        <div class="card-body justify-content-center d-flex">
          <div class="row p-2" #el [style]="{ width: '100%' }">
            <div class="col-6">
              <p class="m-0"><b>Datos personales</b></p>
              <p class="m-0">Nombre y apellido: {{(form.assistants[0].name) ?? 'Sin nombre' }}
                {{(form.assistants[0].last_name) ?? 'Sin definir' }}</p>
              <p class="m-0">Contratista: {{(form.assistants[0].contractor.name) ?? 'Sin definir' }}</p>
            </div>
            <div class="col-6">
              <p class="m-0"><b>Datos de la evaluación</b></p>
              <p class="m-0">Evaluación: {{(form.type.name) ?? 'Sin definir' }}</p>
              <p class="m-0">Categoría: {{form.category.name ?? 'Sin definir'}}</p>
              <p class="m-0">Fecha: {{form.start_date_time | date: 'dd/MM/yyyy'}}</p>
              <p class="m-0">Nota mínima de aprobación: {{form.category.min_grade ?? 'Sin definir'}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row sticky p-2" [style]="{ width: '100%' }" [ngClass]="{'show': !visibility}">
      <div class="col-6">
        <p class="m-0"><b>Nombre y apellido:</b> {{(form.assistants[0].name) ?? 'Sin nombre' }}
          {{(form.assistants[0].last_name) ?? 'Sin definir' }}</p>
      </div>
      <div class="col-6">
        <p class="m-0"><b>Evaluación:</b> {{(form.type.name) ?? 'Sin definir' }}</p>
      </div>
    </div>

    <div class="mt-5">
      <div class="grid">

        <div class="col-12 md:col-6 lg:col-6 mt-4 pl-5 pr-5" *ngFor="let q of evaluation; let index = index">
          <h5 class="mb-2">{{index + 1}}. {{q.name}}</h5>
          <div class="answer">
            <div class="flex align-items-center gap-1 mt-2" *ngFor="let a of q.answers; let index = index">
              <p-checkbox class="mr-2" [(ngModel)]="a.isCorrect" [style]="{ margin: 0 }" [binary]="true"></p-checkbox>
              <label for="ny">{{a.name}}</label>
            </div>
          </div>
        </div>


      </div>

    </div>

    <div class="row mt-5 p-2">
      <div class="card">
        <div class="card-body justify-content-center d-flex p-4">
          <button class="btn btn-primary p-2" (click)="submit()">Cargar evaluación</button>
        </div>
      </div>
    </div>
  </div>

  <app-dialog #dialog></app-dialog>

  <p-dialog [(visible)]="visible" [style]="{width: '90vw'}" [closable]="false" [modal]="true">
    <h3 class="text-center">Evaluación finalizada</h3>
    <h5 class="text-center">La evaluación fue enviada con éxito.</h5>
    <br>
    <p class="text-center">Su puntaje es:</p>
    <div style="width: 100%" class="custom-center">
      <div class="circular-border custom-center text-center">
        <div style="flex: 1; padding: 6px">
          <p class="text-center">{{myScore}}</p>
          <hr>
          <p class="text-center">100</p>
        </div>
      </div>
    </div>

  </p-dialog>
</ng-container>
<app-dialog #dialog></app-dialog>